/**
 * Sidebar Icon
 *
 */

import React from 'react'

export default function about_the_lib(props = {}) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.38397 23.25H2.36597C1.96814 23.25 1.58661 23.092 1.30531 22.8107C1.024 22.5294 0.865967 22.1478 0.865967 21.75V7.5C0.865967 7.10218 1.024 6.72064 1.30531 6.43934C1.58661 6.15804 1.96814 6 2.36597 6H4.38397"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.2354 4.12044L13.8334 4.65369C13.0591 4.94819 12.6701 5.81464 12.9646 6.58895L18.8304 22.0111C19.1249 22.7854 19.9913 23.1744 20.7656 22.8799L22.1676 22.3466C22.942 22.0521 23.3309 21.1857 23.0364 20.4114L17.1707 4.98921C16.8762 4.2149 16.0097 3.82594 15.2354 4.12044Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.366 0.75H8.36597C7.53754 0.75 6.86597 1.42157 6.86597 2.25V21.75C6.86597 22.5784 7.53754 23.25 8.36597 23.25H11.366C12.1944 23.25 12.866 22.5784 12.866 21.75V2.25C12.866 1.42157 12.1944 0.75 11.366 0.75Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.86597 3.75V15.75"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.86597 19.125C9.7918 19.125 9.7193 19.147 9.65763 19.1882C9.59596 19.2294 9.5479 19.288 9.51951 19.3565C9.49113 19.425 9.4837 19.5004 9.49817 19.5732C9.51264 19.6459 9.54836 19.7127 9.6008 19.7652C9.65325 19.8176 9.72007 19.8533 9.79281 19.8678C9.86555 19.8823 9.94095 19.8748 10.0095 19.8465C10.078 19.8181 10.1366 19.77 10.1778 19.7083C10.219 19.6467 10.241 19.5742 10.241 19.5C10.241 19.4005 10.2015 19.3052 10.1311 19.2348C10.0608 19.1645 9.96542 19.125 9.86597 19.125Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
